import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Center,
  Flex,
  Heading,
  useToast,
  VStack
} from '@chakra-ui/react'
import { Form } from './Form'
import useSeasonChallenges from './hooks/useSeasonChallenges'
import { SeasonChallengeFormData } from '@olagg/validation-schemas/seasonChallenge.schema'

const Create = () => {
  const { id: seasonId } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { createChallenge, loading } = useSeasonChallenges()

  const onSubmit = async (data: SeasonChallengeFormData) => {
    if (!seasonId) return

    try {
      await createChallenge(data)
      toast({
        title: 'Desafío creado',
        description: 'El desafío ha sido creado exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(`/seasons/${seasonId}/challenges`)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo crear el desafío',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate(`/seasons/${seasonId}/challenges`)
  }

  if (!seasonId) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          ID de temporada no válido
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Desafío</Heading>
        <Form
          seasonId={seasonId}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={false}
        />
      </VStack>
    </Center>
  )
}

export default Create
